var render = function render(_c,_vm){return _c('button',_vm._g(_vm._b({class:[ _vm.data.class, _vm.data.staticClass ],attrs:{"type":_vm.props.type || 'button',"title":_vm.props.title}},'button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }